const authApi = {
  login: "auth/login",
  logout: "auth/logout",
  signup: "auth/signup",
  forget_password: "auth/forget-password",
  get_citys: "auth/city",
  get_countrys: "auth/country",
  get_citys_by_country: "auth/city-by-country",
  email_check: "auth/email-check",
};
const createProfileAPI = {
  shopify_list: "createProfile/shopify-list",
  shopify_status: "createProfile/shopify-status",
  tags: "createProfile/tags",
  create_profile: "createProfile/create-profile",
  seller_profile: "createProfile/seller-profile" ,
  shopify_profile: "createProfile/shopify-profile",
  seller_collections: "createProfile/seller-collections" ,
  seller_categories: "createProfile/seller-categories" ,
  create_product: "createProfile/create-product" ,
  seller_products: "createProfile/seller-products" ,
  connect_stripe: "createProfile/connect-stripe",
  dashboard : "createProfile/dashboard",
  seller_edit_products: "createProfile/seller-edit-products",
  get_product_id: "createProfile/get-product-id",
  seller_delete_products: "createProfile/seller-delete-products",
  seller_mark_shipped: "createProfile/seller-mark-shipped",
  seller_edit_profile: "createProfile/seller-edit-profile",
  migrate_inventory: "shopify/products/bulk-map",
  seller_colours: "inventory/colours",
  seller_sizes: "inventory/sizes",
  seller_add_colours: "inventory/add-colours",
  seller_add_sizes: "inventory/add-sizes",
  option_types: "inventory/option-types",
  create_option_type: "inventory/create-option-type",
  create_option_value: "inventory/create-option-value",
  get_product_variants: "inventory/get-product-variants",
  update_product_options: "inventory/update-product-options",
  update_product_variants: "inventory/update-product-variants",
  update_variant: "inventory/update-variant",
  delete_variant: "inventory/delete-variant"
};

const paymentsAPI = {
  get_earnings: "payments/get-earnings"
}

const invoicesAPI = {
  get_invoices: "invoices/get-invoices",
  invoice_download: "invoices/invoice-download"
}

export { authApi, createProfileAPI, paymentsAPI, invoicesAPI };
